module.exports = __webpack_public_path__ + "img/lab.897a200e.jpg";